module.exports = __webpack_public_path__ + "static/media/shareplus icon (active).09467ab5.svg";